import React from 'react';

interface TiktokIconProps {
  className?: string;
}

export const TiktokIcon: React.FC<TiktokIconProps> = ({ className }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="currentColor" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.321 5.562a5.122 5.122 0 0 1-3.414-1.267 5.133 5.133 0 0 1-1.343-1.893h-3.92v13.636a2.955 2.955 0 0 1-2.954 2.954 2.955 2.955 0 0 1-2.953-2.954 2.955 2.955 0 0 1 2.953-2.954c.163 0 .322.014.478.039v-3.913a6.894 6.894 0 0 0-.478-.016 6.867 6.867 0 0 0-6.868 6.868 6.867 6.867 0 0 0 6.868 6.868 6.867 6.867 0 0 0 6.868-6.868V9.503a9.008 9.008 0 0 0 5.458 1.824V7.39a5.133 5.133 0 0 1-2.695-.702v-1.126Z" />
    </svg>
  );
}; 